import { render, staticRenderFns } from "./editUserMsg.vue?vue&type=template&id=5cf0e83b&scoped=true&"
import script from "./editUserMsg.vue?vue&type=script&lang=js&"
export * from "./editUserMsg.vue?vue&type=script&lang=js&"
import style0 from "./editUserMsg.vue?vue&type=style&index=0&id=5cf0e83b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf0e83b",
  null
  
)

export default component.exports